import { render, staticRenderFns } from "./RegistroEdit.vue?vue&type=template&id=79c5bdfe&"
import script from "./RegistroEdit.vue?vue&type=script&lang=js&"
export * from "./RegistroEdit.vue?vue&type=script&lang=js&"
import style0 from "./RegistroEdit.vue?vue&type=style&index=0&id=79c5bdfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports